const Menu = ({ width = 20, height = 20, color = 'currentColor' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 26 18" fill="none">
      <path
        d="M12.6667 18H24.3333C25.2533 18 26 17.552 26 17C26 16.448 25.2533 16 24.3333 16H12.6667C11.7467 16 11 16.448 11 17C11 17.552 11.7467 18 12.6667 18Z"
        fill={color}
      />
      <path
        d="M1.625 2H24.375C25.272 2 26 1.552 26 1C26 0.448 25.272 0 24.375 0H1.625C0.728 0 0 0.448 0 1C0 1.552 0.728 2 1.625 2Z"
        fill={color}
      />
      <path
        d="M1.625 10H24.375C25.272 10 26 9.552 26 9C26 8.448 25.272 8 24.375 8H1.625C0.728 8 0 8.448 0 9C0 9.552 0.728 10 1.625 10Z"
        fill={color}
      />
    </svg>
  );
};
export default Menu;
